module.exports = __webpack_public_path__ + "static/media/seunghyun-hong-portrait.3d9a9810.png";